<template>
  <div>
    <div class="jumbotron">
      <div class="mask org"></div>
      <b-row class="pt-5 text-left text-white" style="margin: auto;">
        
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/organizzazioni.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        
        <b-col cols="4" class="">
          <h2>Organizzazioni</h2>
          <p>Archivio</p>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" align-h="center" style="max-width: 1460px">

      <div class="row w-100 mb-2" v-if="isMobile">
        <b-form-input v-model="search" @change="this.getArchivio" class="ml-2 mr-2 search" placeholder="Cerca un documento"></b-form-input>
      </div>

      <!-- FILTRI -->
      <div :id="isMobile ? 'filters-row' : ''" class="text-left" style="width: 100%;">

        <b-form-input v-model="search" v-if="!isMobile" class="search col-lg-3 col-sm-12 m-2 btn-group" :position-fixed="true" :boundary="'viewport'" @change="this.getArchivio" placeholder="Cerca un documento"></b-form-input>

        <!-- Tipo -->
        <b-dropdown id="tipoDropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown">
          
          <template #button-content>
            Tipo<span v-if="type_selected > 0"> <b-badge class="ml-1" variant="warning">{{type_selected}}</b-badge></span>
          </template>

          <b-dropdown-form v-for="(type, index) in type_of_documents" :key="index">

            <b-form-checkbox :class="'tipoCheckbox_'+index" v-model="type.value" >{{ type.label }}</b-form-checkbox>

          </b-dropdown-form>

          <b-dropdown-divider></b-dropdown-divider>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaTipo">SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="salvaTipo" >SALVA</b-button>

        </b-dropdown>

        <!-- Date -->
        <b-dropdown id="dateDropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown2">
          <template #button-content>
            Date<span v-if="date.selected > 0"> <b-badge class="ml-1" variant="warning">{{date.selected}}</b-badge></span>
          </template>

          <b-dropdown-form class="mb-2" @click.stop>

            <label for="data_richiesta">Data Richiesta</label>
            <b-form-datepicker
              id="data_richiesta"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              type="date"
              v-model="date.data_richiesta"
              today-button
              reset-button
            ></b-form-datepicker>

            <label for="data_consegna" class="mt-2">Data Consegna</label>
            <b-form-datepicker
              id="data_consegna"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              type="date"
              v-model="date.data_consegna"
              today-button
              reset-button
              @click.stop
            ></b-form-datepicker>

          </b-dropdown-form>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaDate" >SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="salvaDate" >SALVA</b-button>
        </b-dropdown>

        <!-- Lingua Sorgente -->
        <b-dropdown id="src_lang_dropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown3">
          <template #button-content>
            Lingua Sorgente<span v-if="selectedSrcLangsLength > 0"> <b-badge class="ml-1" variant="warning">{{selectedSrcLangsLength}}</b-badge></span>
          </template>

          <b-dropdown-item-button @click.stop>
            <b-form-input v-model="searchQuery" placeholder="Search..." class="mb-3"></b-form-input>
            <div style="max-height: 250px; overflow-y: auto;">
              <div v-for="(lang, index) in src_langs" :key="index">
                <b-form-checkbox
                v-model="selectedSrcLangs"
                :value="lang.src_language.id"
                >
                  {{ lang.src_language.description }}
                </b-form-checkbox>
              </div>
            </div>
          </b-dropdown-item-button>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaSrcLangs">SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="salvaSrcLangs">SALVA</b-button>
        </b-dropdown>

        <!-- Lingua Destinazione -->
        <b-dropdown id="dest_lang_dropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown4">
          <template #button-content>
            Lingua Destinazione<span v-if="selectedDestLangsLength > 0"> <b-badge class="ml-1" variant="warning">{{selectedDestLangsLength}}</b-badge></span>
          </template>

          <b-dropdown-item-button @click.stop>
            <b-form-input v-model="searchQuery" placeholder="Search..." class="mb-3"></b-form-input>
            <div style="max-height: 250px; overflow-y: auto;">
              <div v-for="(lang, index) in dest_langs" :key="index">
                <b-form-checkbox
                v-model="selectedDestLangs"
                :value="lang.dest_language.id"
                >
                  {{ lang.dest_language.description }}
                </b-form-checkbox>
              </div>
            </div>
          </b-dropdown-item-button>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaDestLangs">SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="salvaDestLangs">SALVA</b-button>

        </b-dropdown>

        <!-- Status -->
        <b-dropdown id="status_dropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown5">
          <template #button-content>
            Status<span v-if="statusLength > 0"> <b-badge class="ml-1" variant="warning">{{statusLength}}</b-badge></span>
          </template>

          <b-dropdown-item-button @click.stop>
            <b-form-checkbox name="check-button" v-model="completato" @change="changeState(1)" size="lg" switch>
              Completato
            </b-form-checkbox>
            <b-form-checkbox name="check-button" v-model="non_completato" @change="changeState(2)" size="lg" switch>
              Non Completato
            </b-form-checkbox>
          </b-dropdown-item-button>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaStatus">SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="salvaStatus">SALVA</b-button>

        </b-dropdown>

        <!-- Audio -->
        <b-dropdown id="audio_dropdown" variant="outline-primary" :position-fixed="true" :boundary="'viewport'" class="m-2 dropdown-fluid" ref="dropdown6">
          <template #button-content>
            Audio<span v-if="con_audio || senza_audio"> <b-badge class="ml-1" variant="warning">1</b-badge></span>
          </template>

          <b-dropdown-item-button @click.stop>
            <b-form-checkbox name="check-button" v-model="con_audio" @change="changeState(3)" size="lg" switch>
              Con Audio
            </b-form-checkbox>
            <b-form-checkbox name="check-button" v-model="senza_audio" @change="changeState(4)" size="lg" switch>
              Senza Audio
            </b-form-checkbox>
          </b-dropdown-item-button>

          <b-button variant="outline-dark" size="sm" class="ml-2 mr-2" @click="svuotaAudio">SVUOTA</b-button>
          <b-button variant="primary" size="sm" class="mr-2" @click="chiudiAudio">CHIUDI</b-button>

        </b-dropdown>

        <!-- Svuota Filtri -->
        <b-button 
          variant="outline-primary" 
          size="sm" 
          class="m-2 button-fluid"
          v-if="filtriAttivati > 0"
          @click="svuotaFiltri"
          v-b-tooltip.hover title="Svuota Filtri"
          ><font-awesome-icon icon="trash" style="font-size: 25px;"/>
        </b-button>

      </div>

      <div class="col-12 text-left">
        <p style="color: gray; font-size: 1rem;"><b-icon-search></b-icon-search> {{ this.con_audio ? this.documents.filter(document => document.audio_exists).length : this.senza_audio ? this.documents.filter(document => !document.audio_exists).length : documents.length }} 
        documenti trovati</p>
      </div>

      <b-table style="width: 100%" striped sticky-header="61vh" @row-clicked="onRowClicked" hover :small="isMobile" :items="filteredDocuments" :fields="fields">

        <template v-slot:cell(status_id)="data">
          <!-- <div>{{data.item.status_id}} <div class="dot" style="background-color: green!important;"></div></div> -->
          <div class="mt-auto mb-auto" v-if="data.item.status_id == 5"> <div class="dot" style="background-color: green!important;"></div></div>
          <div v-if="data.item.status_id == 1 || data.item.status_id == 4"> <div class="dot" style="background-color: orange!important;"></div></div>
        </template>

        <template v-slot:cell(name2)="data">
          <p class="mt-0 mb-0" style="font-size: 1rem;">{{data.item.name}}</p>
          <p class="mt-0 mb-0" style="font-size: 0.8rem; color: gray;">{{data.item.src_language.description}} -> {{data.item.dest_language.description}}</p>
        </template>

        <template v-slot:cell(src_language)="data">
          <div>{{data.item.src_language.description}}</div>
        </template>

        <template v-slot:cell(dest_language)="data">
          <div>{{data.item.dest_language.description}}</div>
        </template>

        <template v-slot:cell(download)="data">
          
          <!-- tasto cancella documento -->
          <b-button
            pill
            @click="delItem(data.item.id)"
            variant="outline-secondary"
            v-if="data.item.status_id == 1"
            class="mr-2 btn-circle"
            v-b-tooltip.hover
            title="Elimina Richieste"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>

          <!-- tasto scarica documento -->
          <b-button
            pill
            @click.prevent="download(`${data.item.id}/original/${data.item.name}`)"
            variant="outline-primary"
            class="btn-circle"
            v-b-tooltip.hover
            title="Scarica Documento Originale"
          >
            <b-icon-file-earmark></b-icon-file-earmark>
          </b-button>

          <!-- tasto scarica documento tradotto -->
          <b-button
            pill
            @click.prevent="download(`${data.item.id}/reviewed/${data.item.name}`)"
            variant="outline-warning"
            class="ml-2 btn-circle"
            v-if="data.item.delivery_date"
            :href="`${data.item.id}/reviewed/${data.item.name}`"
            v-b-tooltip.hover
            title="Scarica Documento Tradotto"
          >
            <b-icon-file-earmark-check></b-icon-file-earmark-check>
          </b-button>

          <!-- tasto scarica traduzione audio -->
          <b-button
            pill
            @click.prevent="download(`${data.item.id}/audio/${data.item.name}`)"
            variant="outline-success"
            v-if="data.item.delivery_date && data.item.audio_exists"
            class="btn-circle ml-2"
            title="Scarica Traduzione Audio"
            v-b-tooltip.hover
          >
            <b-icon-music-note></b-icon-music-note>
          </b-button>
        </template>

      </b-table>

      <!-- Info modal -->
      <b-modal :id="infoModal.id" centered ok-only>
        <div v-html="infoModal.content"></div>

        <div class='row text-center mt-3'>
            <!-- tasto cancella documento -->
          <b-button
            pill
            @click="delItem(infoModal.item_id)"
            variant="outline-secondary"
            v-if="infoModal.show_delete_button"
            class="mr-2 btn-circle col"
            v-b-tooltip.hover
            title="Elimina Richieste"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>

          <!-- tasto scarica documento -->
          <b-button
            pill
            @click.prevent="download(`${infoModal.item_id}/original/${infoModal.name}`)"
            variant="outline-primary"
            class="btn-circle col"
            v-b-tooltip.hover
            title="Scarica Documento Originale"
          >
            <b-icon-file-earmark></b-icon-file-earmark>
          </b-button>

          <!-- tasto scarica documento tradotto -->
          <b-button
            pill
            @click.prevent="download(`${infoModal.item_id}/reviewed/${infoModal.name}`)"
            variant="outline-warning"
            class="ml-2 btn-circle col"
            v-if="infoModal.download_translated_document"
            :href="`${infoModal.item_id}/reviewed/${infoModal.name}`"
            v-b-tooltip.hover
            title="Scarica Documento Tradotto"
          >
            <b-icon-file-earmark-check></b-icon-file-earmark-check>
          </b-button>

          <!-- tasto scarica traduzione audio -->
          <b-button
            pill
            @click.prevent="download(`${infoModal.item_id}/audio/${infoModal.name}`)"
            variant="outline-success"
            v-if="infoModal.download_translated_audio_document"
            class="btn-circle ml-2 col"
            title="Scarica Traduzione Audio"
            v-b-tooltip.hover
          >
            <b-icon-music-note></b-icon-music-note>
          </b-button>
        </div>
      </b-modal>

    </b-row>

  </div>
</template>

<script>
import Util from "@/mixing/util";
import UserService from "@/services/user.service";

export default {
  mixins: [Util],
  computed: {
    filteredDocuments() {
      if(this.con_audio){
        return this.documents.filter(document => document.audio_exists);
      }
      else if(this.senza_audio){
        return this.documents.filter(document => !document.audio_exists);
      }
      else{
        return this.documents;
      }
    }
  },
  data() {
    return {
      user: [],
      documents: [],
      fields: [],
      isMobile: false,
      infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
      type_of_documents: [
        {
          label: 'Generico',
          value: false
        },
        {
          label: 'Legale',
          value: false
        },
        {
          label: 'Brochure/promozione',
          value: false
        },
        {
          label: 'Sanitario/Medico',
          value: false
        },
        {
          label: 'Sociale/sindacale',
          value: false
        }
      ],
      type_of_documents_copy: [
        {
          label: 'Generico',
          value: false
        },
        {
          label: 'Legale',
          value: false
        },
        {
          label: 'Brochure/promozione',
          value: false
        },
        {
          label: 'Sanitario/Medico',
          value: false
        },
        {
          label: 'Sociale/sindacale',
          value: false
        }
      ],
      type_selected: 0,
      date: {
        data_richiesta: "",
        data_consegna: "",
        selected: 0
      },
      closeDropdown: true,
      src_langs: [],
      dest_langs: [],
      selectedSrcLangs: [],
      selectedSrcLangsLength: 0,
      selectedDestLangs: [],
      selectedDestLangsLength: 0,
      searchQuery: '',
      completato: false,
      non_completato: false,
      statusLength: 0,
      con_audio: false,
      senza_audio: false,
      audioLength: 0,
      filtriAttivati: 0,
      search: "",
    };
  },
  created() {
    
    UserService.whoAmI()
      .then((response) => (this.user = response.data))
      .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login/organization");
      });

    this.getArchivio();

    this.checkWindowSize();
    window.addEventListener('resize', this.checkWindowSize);
    
    this.getFiltri();
    this.getSrcLanguages();
    this.getDestLanguages();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWindowSize);
  },
  watch: {
  },
  methods: {
    onRowClicked(item) {

      if(this.isMobile){
        this.infoModal.name = item.name;
        var html = "";

        html += "<div class='row text-center'>";

        html += "<div class='col-12'>";
        html += "<p class='mt-0 mb-0' style='font-size: 1.0rem; text-wrap: wrap;'><b>" + item.name + "</b></p>";
        html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Nome Documento</p>";
        html += "</div>";

        html += "<div class='col-12'>";
        html += "<p class='mt-0 mb-0' style='font-size: 1.2rem; text-wrap: wrap;'><b>" + item.document_type + "</b></p>";
        html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Tipo Documento</p>";
        html += "</div>";

        html += "<div class='col-6'>";
        html += "<p class='mt-0 mb-0' style='font-size: 1.2rem;'><b>" + item.src_language.description + "</b></p>";
        html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Lingua Sorgente</p>";
        html += "</div>";

        html += "<div class='col-6'>";
        html += "<p class='mt-0 mb-0' style='font-size: 1.2rem;'><b>" + item.dest_language.description + "</b></p>";
        html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Lingua Destinazione</p>";
        html += "</div>";

        html += "</div>";
        html += "<div class='row text-center mt-3'>";

        html += "<div class='col'>";
        html += "<p class='mt-0 mb-0' style='font-size: 1.2rem;'><b>" + item.due_date + "</b></p>";
        html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Data Richiesta</p>";
        html += "</div>";

        if(item.delivery_date){
          html += "<div class='col-6'>";
          html += "<p class='mt-0 mb-0' style='font-size: 1.2rem;'><b>" + item.delivery_date + "</b></p>";
          html += "<p class='mt-0 mb-0' style='font-size: 0.8rem; color: gray;'>Data Consegna</p>";
          html += "</div>";
        }

        html += "</div>";
        
        this.infoModal.content = html;
        this.infoModal.item_id = item.id;
        
        if(item.status_id == 1)
          this.infoModal.show_delete_button = true;
        else
          this.infoModal.show_delete_button = false;

        if(item.delivery_date)
          this.infoModal.download_translated_document = true;
        else
          this.infoModal.download_translated_document = false;

        if(item.delivery_date && item.audio_exists)
          this.infoModal.download_translated_audio_document = true;
        else
          this.infoModal.download_translated_audio_document = false;

        this.$root.$emit('bv::show::modal', this.infoModal.id);
      }
    },
    getArchivio(){
      this.getFiltri();
      // this.getSrcLanguages();
      UserService.getArchivio(window.location.search).then((response) => {
        this.documents = response.data;
      }).catch((error) => {
        console.log("getArchivio error: " + error);
      });
    },
    getSrcLanguages(){
      UserService.getSrcLanguages(window.location.search).then((response) => {
        this.src_langs = response.data;
      });
    },
    getDestLanguages(){
      UserService.getDestLanguages(window.location.search).then((response) => {
        this.dest_langs = response.data;
      });
    },
    delItem(document_id) {
      this.$bvModal.msgBoxConfirm("Vuoi davvero cancellare questa richiesta?").then((res) => {
        if (res) {
          UserService.delDoc(document_id).then(() => {
            this.getArchivio();
          });
        }
      });
    },
    checkWindowSize() {
      if(window.innerWidth <= 1110){
        this.fields= [
          {
            key: "status_id",
            label: "",
            class: 'align-middle',
            sortable: true
          },
          {
            key: "name2",
            label: "Nome Documento",
            class: "text-left wrap",
            sortable: true
          },
          {
            key: "download2",
            label: "",
          }
        ];
        this.isMobile = true;
      } else {
        this.fields = [
        {
          key: "status_id",
          label: ""
        },
        {
          key: "name",
          label: "Nome Documento",
          sortable: true
        },
        {
          key: "document_type",
          label: "Tipo Documento",
          sortable: true
        },
        {
          key: "src_language",
          label: "Lingua Sorgente",
          sortable: true
        },
        {
          key: "dest_language",
          label: "Lingua Destinazione",
          sortable: true
        },
        {
          key: "due_date",
          label: "Data Richiesta",
          sortable: true
        },
        {
          key: "delivery_date",
          label: "Data Consegna",
          sortable: true
        },
        {
          key: "download",
          label: "Azioni",
        }
      ];
      this.isMobile = false;
      }
    },
    salvaTipo(){
      let selected = 0;
      for (let index = 0; index < this.type_of_documents.length; index++) {
        this.type_of_documents_copy[index].value = this.type_of_documents[index].value;

        if(this.type_of_documents_copy[index].value){
          selected++;
        }
      }

      this.type_selected = selected;
      this.getArchivio();
      this.setActive(selected, 'tipoDropdown__BV_toggle_');
      this.$refs.dropdown.hide(true);
    },
    svuotaTipo(){
      for (let index = 0; index < this.type_of_documents.length; index++) {
        // this.type_of_documents_copy[index].value = false;
        this.type_of_documents[index].value = false;
      }
    },
    salvaDate(){
      this.date.selected = 0;

      if(this.date.data_richiesta)
        this.date.selected++;

      if(this.date.data_consegna)
        this.date.selected++;
      
      this.setActive(this.date.selected, 'dateDropdown__BV_toggle_');
      this.getArchivio();

      this.closeDropdown = false;
      this.$nextTick(() => {
        this.$refs.dropdown2.hide(true);
        this.$nextTick(() => {
          this.closeDropdown = true;
        });
      });
    },
    svuotaDate(){
      this.date.data_richiesta = "";
      this.date.data_consegna = "";
      this.date.selected = 0;
    },
    salvaSrcLangs(){
      this.selectedSrcLangsLength = this.selectedSrcLangs.length;
      this.closeDropdown = false;
      this.setActive(this.selectedSrcLangsLength, 'src_lang_dropdown__BV_toggle_');
      this.getArchivio();
      this.$nextTick(() => {
        this.$refs.dropdown3.hide(true);
        this.$nextTick(() => {
          this.closeDropdown = true;
          this.searchQuery = '';
        });
      });
    },
    svuotaSrcLangs(){
      this.selectedSrcLangs = [];
      this.selectedSrcLangsLength = this.selectedSrcLangs.length;
    },
    salvaDestLangs(){
      this.selectedDestLangsLength = this.selectedDestLangs.length;
      this.closeDropdown = false;
      this.setActive(this.selectedDestLangsLength, 'dest_lang_dropdown__BV_toggle_');
      this.getArchivio();
      this.$nextTick(() => {
        this.$refs.dropdown4.hide(true);
        this.$nextTick(() => {
          this.closeDropdown = true;
          this.searchQuery = '';
        });
      });
    },
    svuotaDestLangs(){
      this.selectedDestLangs = [];
      this.selectedDestLangsLength = this.selectedDestLangs.length;
    },
    setActive(selected, id){
      const element = document.getElementById(id);
      if(selected > 0 && element){
        element.classList.add('active');
        this.filtriAttivati++;
      } else {
        element.classList.remove('active');
        this.filtriAttivati--;
      }

      this.filtriAttivati = document.getElementsByClassName('active').length;
    },
    changeState(checkbox){
      if(checkbox == 1){
        this.non_completato = false;
      } else if (checkbox == 2){
        this.completato = false;
      } else if (checkbox == 3){
        this.senza_audio = false;
      } else if (checkbox == 4){
        this.con_audio = false;
      }
    },
    salvaStatus(){
      if(this.completato || this.non_completato){
        this.setActive(1, 'status_dropdown__BV_toggle_');
        this.statusLength = 1;  
      } else if (!this.completato && !this.non_completato){
        this.statusLength = 0;
        this.setActive(0, 'status_dropdown__BV_toggle_');
      }

      this.closeDropdown = false;
      this.getArchivio();
      this.$nextTick(() => {
        this.$refs.dropdown5.hide(true);
        this.$nextTick(() => {
            this.closeDropdown = true;
          });
      });
    },
    svuotaStatus(){
      this.completato = false;
      this.non_completato = false;
      this.statusLength = 0;
    },
    chiudiAudio(){
      if(this.con_audio || this.senza_audio){
        this.setActive(1, 'audio_dropdown__BV_toggle_');
      } else if (!this.con_audio && !this.senza_audio){
        this.setActive(0, 'audio_dropdown__BV_toggle_');
      }

      this.closeDropdown = false;
      this.$nextTick(() => {
        this.$refs.dropdown6.hide(true);
        this.$nextTick(() => {
            this.closeDropdown = true;
          });
      });
    },
    svuotaAudio(){
      this.con_audio = false;
      this.senza_audio = false;
      this.audioLength = 0;
    },
    svuotaFiltri(){
      this.svuotaTipo();
      this.salvaTipo();
      this.svuotaDate();
      this.svuotaSrcLangs();
      this.svuotaDestLangs();
      this.svuotaStatus();
      this.svuotaAudio();
      this.filtriAttivati = 0;
      this.getArchivio();
      this.search = "";

      for (let index = 0; index < document.getElementsByClassName('active').length; index++) {
        document.getElementsByClassName('active')[index].classList.remove('active');
      }
    },
    closeAllDropdowns(){
      this.closeDropdown = false;
      setTimeout(() => {
        this.closeDropdown = true;
      }, 10);
    },
    getFiltri(){
      var tipo_arr = [];
      for (let index = 0; index < this.type_of_documents.length; index++) {
        if(this.type_of_documents[index].value)
          tipo_arr.push(this.type_of_documents[index].label)
      }

      this.$router.push({
        query: {
          type: JSON.stringify(tipo_arr),
          data_richiesta: this.date.data_richiesta,
          data_consegna: this.date.data_consegna,
          src_langs: JSON.stringify(this.selectedSrcLangs),
          dest_langs: JSON.stringify(this.selectedDestLangs),
          status: this.completato ? 1 : this.non_completato ? 2 : '',
          search: this.search ? this.search : '',
        }
      });
    }
  },
  mounted() {

    this.$root.$on('bv::dropdown::show', bvEvent => {
      if(bvEvent.componentId == 'tipoDropdown'){
        for (let index = 0; index < this.type_of_documents.length; index++) {
          this.type_of_documents[index].value = this.type_of_documents_copy[index].value;
        }
        this.closeAllDropdowns();
      }

      console.log(bvEvent.componentId);

      if(bvEvent.componentId == 'dateDropdown') this.closeAllDropdowns();
      if(bvEvent.componentId == 'src_lang_dropdown') this.closeAllDropdowns();
      if(bvEvent.componentId == 'dest_lang_dropdown') this.closeAllDropdowns();
      if(bvEvent.componentId == 'status_dropdown') this.closeAllDropdowns();
      if(bvEvent.componentId == 'audio_dropdown') this.closeAllDropdowns();
    });

    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if(bvEvent.componentId == 'dateDropdown' && this.closeDropdown) bvEvent.preventDefault();
      if(bvEvent.componentId == 'src_lang_dropdown' && this.closeDropdown) bvEvent.preventDefault();
      if(bvEvent.componentId == 'dest_lang_dropdown' && this.closeDropdown) bvEvent.preventDefault();
      if(bvEvent.componentId == 'status_dropdown' && this.closeDropdown) bvEvent.preventDefault();
      if(bvEvent.componentId == 'audio_dropdown' && this.closeDropdown) bvEvent.preventDefault();
    });
  }
};
</script>
<style>
.dot {
  height: 20px;
  width: 20px;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
}
.jumbotron {
  background-image: url("/img/bg-org.png");
}
.mask.org {
  background-color: #ff2300;
}
.butFile {
  border-radius: 0 25px 25px 0 !important;
  margin-left: -15px;
  z-index: 0;
  margin-bottom: 2px;
  height: 38px;
}
.btn-outline-primary,
.btn-outline-danger {
  z-index: 1;
}
.border-danger,
.btn-outline-secondary,
.btn-outline-primary,
.btn-outline-danger {
  border-width: 2px !important;
}

.wrap{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
}

#filters-row{
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 1rem;
  width: 100%;
  padding-right: 0.5rem;
}

#filters-row button:hover{
  border-color: #e18932;
  color: #e18932;
  background-color: whitesmoke;
}

.search{
  border: 2px solid #f49537!important;
  color: #f49537!important;
  /* height: 45px!important; */
}

.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle{
    border-color: #e18932!important;
    color: #e18932!important;
    background-color: whitesmoke!important;
}

.active{
  background-color: whitesmoke!important;
  /* border-color: #e18932!important; */
  color: #e18932!important;
  border: 3px solid #e18932!important;
}

.b-calendar .b-calendar-grid-body .col[data-date] .btn{
  width: 32px!important;
  height: 32px!important;
}

#data_consegna__dialog_{
  transform: none!important;
}

#data_richiesta__dialog_{
  transform: none!important;
}

#dest_lang_dropdown__BV_toggle_{
  width: 100%!important;
}

.dropdown-fluid .dropdown-toggle {
  width: auto !important; /* Larghezza automatica */
  display: inline-block; /* Adatta la larghezza al contenuto */
  white-space: nowrap; /* Impedisce che il testo venga mandato a capo */
}

.button-fluid {
  max-width: 5rem !important;
  display: inline-block;   /* Adatta la larghezza al contenuto */
  white-space: nowrap;     /* Evita il wrapping del testo */
}


</style>
